import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  Apikey,
  ApikeyPermission,
  CreateApikeyRequestData,
  GetApikeyPermissionsParams,
  GetApikeysParams,
  UpdateApikeyRequestData,
} from '../types';

export function useApiKeysApi() {
  return useMemo(
    () => ({
      getApikeys: (params: GetApikeysParams) => {
        return apiClient.get<{ items: Apikey[]; count: number }>(`/api-keys`, { params });
      },

      createApikey: (data: CreateApikeyRequestData, companyId: string) => {
        return apiClient.post<Apikey>(`/api-keys`, data, { params: { companyId } });
      },

      updateApikey: (data: UpdateApikeyRequestData, apikeyId: string, companyId: string) => {
        return apiClient.put<Apikey>(`/api-keys/${apikeyId}`, data, { params: { companyId } });
      },

      deleteApikeys: (ids: string[], companyId: string) => {
        return apiClient.delete<void>(`/api-keys`, { data: { ids }, params: { companyId } });
      },

      renewApikey: (apikeyId: string, companyId: string) => {
        return apiClient.post<Apikey>(`/api-keys/${apikeyId}/renew`, {}, { params: { companyId } });
      },

      getApikeyPermissions: (params: GetApikeyPermissionsParams) => {
        return apiClient.get<{ items: ApikeyPermission[]; count: number }>(`/api-keys/permissions`, {
          params,
        });
      },
    }),
    [],
  );
}
